module.exports = __webpack_public_path__ + "assets/img/Travel_003.d724114b-ps.jpg";